import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import Button from 'src/components/ui/Button';
import { getSuccessMessage } from 'src/utils/maintenance';

/**
 * Terminal screen shown once an event is completed or cancelled: a status
 * badge, heading, the operator-facing summary copy, and a reset action.
 * Presentational only — all derivation lives in `getSuccessMessage`.
 */
const MaintenanceSuccess = ({ successState, onReset }) => {
  const isCancelled = successState.type === 'cancelled';
  return (
    <div className='text-center' style={{ padding: '44px 20px' }}>
      <div className={`mnt-success__badge${isCancelled ? ' mnt-success__badge--cancel' : ''}`}>
        <FontAwesomeIcon icon={isCancelled ? faXmark : faCheck} />
      </div>
      <h2 className='h4 mt-3'>
        {isCancelled
          ? 'Event cancelled'
          : successState.type === 'planned'
            ? 'Event planned'
            : 'Maintenance complete'}
      </h2>
      <p className='text-muted mx-auto' style={{ maxWidth: 280 }}>
        {getSuccessMessage(successState)}
      </p>
      <Button fill block variant='primary' size='large' className='mt-4' onClick={onReset}>
        Back to Maintenance
      </Button>
    </div>
  );
};

MaintenanceSuccess.propTypes = {
  successState: PropTypes.shape({
    type: PropTypes.string.isRequired,
    wasPlanned: PropTypes.bool,
    hadDowntime: PropTypes.bool,
    freeNow: PropTypes.bool,
  }).isRequired,
  onReset: PropTypes.func.isRequired,
};

export default MaintenanceSuccess;
